import React from 'react';
import PropTypes from 'prop-types';
import {
  DeleteConfirmationModal,
  CSATEditModal,
  ProgressEditModal,
  EffortEditModal,
  ProjectUnitEditModal,
  AuditEditModal,
  RiskEditModal,
  IssueEditModal,
  InfoSecEditModal,
} from '../expandableSectionsModals';

const ProjectDetailsSectionModals = ({
  modalState,
  closeModal,
  csatCustomers,
  csatCustomersLoading,
  csatCustomersError,
  submitCSATEdit,
  confirmCSATDelete,
  isActionInProgress,
  onCSATHistoryClick,
  submitProgressEdit,
  isProgressEditMode,
  confirmProgressDelete,
  projectUnitsData,
  submitProjectUnitEdit,
  isProjectUnitEditMode,
  confirmProjectUnitDelete,
  effortsData,
  submitEffortEdit,
  confirmEffortDelete,
  submitAuditEdit,
  isAuditEditMode,
  confirmAuditDelete,
  riskRegisterData,
  submitRiskEdit,
  isRiskEditMode,
  confirmRiskDelete,
  submitIssueEdit,
  isIssueEditMode,
  confirmIssueDelete,
  submitInfoSecEdit,
  isInfoSecEditMode,
  confirmInfoSecDelete,
}) => (
  <>
    <CSATEditModal
      isOpen={modalState.csatEdit.isOpen}
      data={modalState.csatEdit.data}
      customers={csatCustomers}
      isCustomersLoading={csatCustomersLoading}
      customersError={csatCustomersError}
      onClose={() => closeModal('csatEdit')}
      onHistory={onCSATHistoryClick}
      onSubmit={submitCSATEdit}
      isSubmitting={isActionInProgress}
    />
    <DeleteConfirmationModal
      isOpen={modalState.csatDelete.isOpen}
      title="Delete CSAT"
      message="Are you sure you want to delete this CSAT ?"
      onClose={() => closeModal('csatDelete')}
      onConfirm={confirmCSATDelete}
      isSubmitting={isActionInProgress}
    />

    <ProgressEditModal
      isOpen={modalState.progressEdit.isOpen}
      data={modalState.progressEdit.data}
      onClose={() => closeModal('progressEdit')}
      onSubmit={submitProgressEdit}
      isSubmitting={isActionInProgress}
      title={isProgressEditMode ? 'Update Progress %' : 'Add Progress %'}
      submitLabel={isProgressEditMode ? 'Update' : 'Add'}
      submittingLabel={isProgressEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.progressDelete.isOpen}
      title="Delete progress"
      message="Are you sure you want to delete this progress ?"
      onClose={() => closeModal('progressDelete')}
      onConfirm={confirmProgressDelete}
      isSubmitting={isActionInProgress}
    />

    <ProjectUnitEditModal
      isOpen={modalState.projectUnitEdit.isOpen}
      data={modalState.projectUnitEdit.data}
      categoryOptions={projectUnitsData?.resourceCategoryOptions || []}
      onClose={() => closeModal('projectUnitEdit')}
      onSubmit={submitProjectUnitEdit}
      isSubmitting={isActionInProgress}
      title={isProjectUnitEditMode ? 'Update Unit' : 'Add New Unit'}
      submitLabel={isProjectUnitEditMode ? 'Update' : 'Add'}
      submittingLabel={isProjectUnitEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.projectUnitDelete.isOpen}
      title="Delete project unit"
      message="Are you sure you want to delete this project unit?"
      onClose={() => closeModal('projectUnitDelete')}
      onConfirm={confirmProjectUnitDelete}
      isSubmitting={isActionInProgress}
    />

    <EffortEditModal
      isOpen={modalState.effortEdit.isOpen}
      data={modalState.effortEdit.data}
      categoryOptions={effortsData?.resourceCategoryOptions || []}
      typeOptions={effortsData?.resourceTypeOptions || []}
      onClose={() => closeModal('effortEdit')}
      onSubmit={submitEffortEdit}
      isSubmitting={isActionInProgress}
      title="Update effort"
      submitLabel="Update"
      submittingLabel="Updating..."
    />
    <DeleteConfirmationModal
      isOpen={modalState.effortDelete.isOpen}
      title="Delete effort"
      message="Are you sure you want to delete this effort ?"
      onClose={() => closeModal('effortDelete')}
      onConfirm={confirmEffortDelete}
      isSubmitting={isActionInProgress}
    />

    <AuditEditModal
      isOpen={modalState.auditEdit.isOpen}
      data={modalState.auditEdit.data}
      onClose={() => closeModal('auditEdit')}
      onSubmit={submitAuditEdit}
      isSubmitting={isActionInProgress}
      title={isAuditEditMode ? 'Update audit score' : 'Add audit score'}
      submitLabel={isAuditEditMode ? 'Update' : 'Add'}
      submittingLabel={isAuditEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.auditDelete.isOpen}
      title="Delete audit score"
      message="Are you sure you want to delete this audit score ?"
      onClose={() => closeModal('auditDelete')}
      onConfirm={confirmAuditDelete}
      isSubmitting={isActionInProgress}
    />

    <RiskEditModal
      isOpen={modalState.riskEdit.isOpen}
      data={modalState.riskEdit.data}
      categoryOptions={riskRegisterData?.riskCategoryOptions || []}
      impactOptions={riskRegisterData?.riskImpactOptions || []}
      riskStatusOptions={riskRegisterData?.riskStatusOptions || []}
      likelihoodOptions={riskRegisterData?.riskLikelihoodOptions || []}
      mitigationOptions={riskRegisterData?.riskMitigationOptions || []}
      onClose={() => closeModal('riskEdit')}
      onSubmit={submitRiskEdit}
      isSubmitting={isActionInProgress}
      title={isRiskEditMode ? 'Update Risk' : 'Add Risk'}
      submitLabel={isRiskEditMode ? 'Update' : 'Add'}
      submittingLabel={isRiskEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.riskDelete.isOpen}
      title="Delete Risk"
      message="Are you sure you want to delete this Risk ?"
      onClose={() => closeModal('riskDelete')}
      onConfirm={confirmRiskDelete}
      isSubmitting={isActionInProgress}
    />

    <IssueEditModal
      isOpen={modalState.issueEdit.isOpen}
      data={modalState.issueEdit.data}
      statusOptions={riskRegisterData?.issueStatusOptions || []}
      categoryOptions={riskRegisterData?.issueCategoryOptions || []}
      impactOptions={riskRegisterData?.riskImpactOptions || []}
      onClose={() => closeModal('issueEdit')}
      onSubmit={submitIssueEdit}
      isSubmitting={isActionInProgress}
      title={isIssueEditMode ? 'Update Issue' : 'Add Issue'}
      submitLabel={isIssueEditMode ? 'Update' : 'Add'}
      submittingLabel={isIssueEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.issueDelete.isOpen}
      title="Delete Issue"
      message="Are you sure you want to delete this Issue ?"
      onClose={() => closeModal('issueDelete')}
      onConfirm={confirmIssueDelete}
      isSubmitting={isActionInProgress}
    />

    <InfoSecEditModal
      isOpen={modalState.infoSecEdit.isOpen}
      data={modalState.infoSecEdit.data}
      categoryOptions={riskRegisterData?.riskAssetCategoryOptions || riskRegisterData?.riskCategoryOptions || []}
      impactOptions={riskRegisterData?.riskImpactOptions || []}
      riskStatusOptions={riskRegisterData?.riskStatusOptions || []}
      likelihoodOptions={riskRegisterData?.riskLikelihoodOptions || []}
      mitigationOptions={riskRegisterData?.riskMitigationOptions || []}
      onClose={() => closeModal('infoSecEdit')}
      onSubmit={submitInfoSecEdit}
      isSubmitting={isActionInProgress}
      title={isInfoSecEditMode ? 'Update Infosec Risk' : 'Add Infosec Risk'}
      submitLabel={isInfoSecEditMode ? 'Update' : 'Add'}
      submittingLabel={isInfoSecEditMode ? 'Updating...' : 'Adding...'}
    />
    <DeleteConfirmationModal
      isOpen={modalState.infoSecDelete.isOpen}
      title="Delete Infosec Risk"
      message="Are you sure you want to delete this Infosec risk ?"
      onClose={() => closeModal('infoSecDelete')}
      onConfirm={confirmInfoSecDelete}
      isSubmitting={isActionInProgress}
    />
  </>
);

ProjectDetailsSectionModals.propTypes = {
  modalState: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  csatCustomers: PropTypes.array.isRequired,
  csatCustomersLoading: PropTypes.bool.isRequired,
  csatCustomersError: PropTypes.string,
  submitCSATEdit: PropTypes.func.isRequired,
  confirmCSATDelete: PropTypes.func.isRequired,
  isActionInProgress: PropTypes.bool.isRequired,
  onCSATHistoryClick: PropTypes.func,
  submitProgressEdit: PropTypes.func.isRequired,
  isProgressEditMode: PropTypes.bool.isRequired,
  confirmProgressDelete: PropTypes.func.isRequired,
  projectUnitsData: PropTypes.object.isRequired,
  submitProjectUnitEdit: PropTypes.func.isRequired,
  isProjectUnitEditMode: PropTypes.bool.isRequired,
  confirmProjectUnitDelete: PropTypes.func.isRequired,
  effortsData: PropTypes.object.isRequired,
  submitEffortEdit: PropTypes.func.isRequired,
  confirmEffortDelete: PropTypes.func.isRequired,
  submitAuditEdit: PropTypes.func.isRequired,
  isAuditEditMode: PropTypes.bool.isRequired,
  confirmAuditDelete: PropTypes.func.isRequired,
  riskRegisterData: PropTypes.object.isRequired,
  submitRiskEdit: PropTypes.func.isRequired,
  isRiskEditMode: PropTypes.bool.isRequired,
  confirmRiskDelete: PropTypes.func.isRequired,
  submitIssueEdit: PropTypes.func.isRequired,
  isIssueEditMode: PropTypes.bool.isRequired,
  confirmIssueDelete: PropTypes.func.isRequired,
  submitInfoSecEdit: PropTypes.func.isRequired,
  isInfoSecEditMode: PropTypes.bool.isRequired,
  confirmInfoSecDelete: PropTypes.func.isRequired,
};

export default ProjectDetailsSectionModals;
